// src/components/AdminProtectedRoute.tsx
// Csak az léphet be, akit a BACKEND adminnak ismer el (nem a Clerk metadata dönt).
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useUser } from "@clerk/clerk-react";
import { useIsAdmin } from "../hooks/useIsAdmin";

const AdminProtectedRoute: React.FC = () => {
    const { isLoaded, isSignedIn } = useUser();
    const { isAdmin, checked } = useIsAdmin();

    if (!isLoaded || !checked) {
        return (
            <Box sx={{ width: "100vw", minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!isSignedIn) {
        return <Navigate to="/authpages" state={{ isLogin: true }} replace />;
    }

    if (!isAdmin) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default AdminProtectedRoute;